import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { xtreamApi } from '../services/xtreamApi';
import VideoPlayer from '../components/Player/VideoPlayer';
import LoadingSpinner from '../components/Common/LoadingSpinner';

const LivePlayerPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [channel, setChannel] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchChannel = async () => {
      try {
        const streams = await xtreamApi.getLiveStreams();
        const found = streams.find(s => s.stream_id === parseInt(id));
        if (found) setChannel(found);
      } catch (err) {
        console.error('Error fetching channel:', err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchChannel();
  }, [id]);

  if (isLoading) {
    return (
      <div className="fixed inset-0 bg-black z-50 flex items-center justify-center">
        <LoadingSpinner size="large" text="Loading channel..." />
      </div>
    );
  }

  const streamUrl = xtreamApi.getStreamUrl(id, 'live', 'm3u8');

  return (
    <div className="fixed inset-0 bg-black z-50">
      <VideoPlayer
        src={streamUrl}
        poster={channel?.stream_icon}
        title={channel?.name || 'Live TV'}
        onBack={() => navigate(-1)}
        isLive={true}
      />
    </div>
  );
};

export default LivePlayerPage;
